import { render } from "./ContentVideo.vue?vue&type=template&id=fc55e142"
import script from "./ContentVideo.vue?vue&type=script&lang=js"
export * from "./ContentVideo.vue?vue&type=script&lang=js"

import "./ContentVideo.vue?vue&type=style&index=0&id=fc55e142&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__